/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Filter_EmailInputs */

const en_home_v2_filter_email = /** @type {(inputs: Home_V2_Filter_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const es_home_v2_filter_email = /** @type {(inputs: Home_V2_Filter_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Home_V2_Filter_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_filter_email = /** @type {((inputs?: Home_V2_Filter_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Filter_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_filter_email(inputs)
	return en_home_v2_filter_email(inputs)
});